"use strict";

const WL_STORAGE = "mm__wishlist-items";
const WL_META = "mm__wishlist-meta";
const WL_SORT = "mm__wishlist-sort";

const WishlistMeta = {
  readItems() {
    try {
      const raw = localStorage.getItem(WL_STORAGE);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      localStorage.removeItem(WL_STORAGE);
      return [];
    }
  },

  writeItems(items) {
    localStorage.setItem(WL_STORAGE, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent("theme:wishlist-updated", { detail: { count: items.length } })
    );
    window.themeHeaderCounters?.refreshWishlist?.();
  },

  readMeta() {
    try {
      const raw = localStorage.getItem(WL_META);
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  },

  writeMeta(meta) {
    localStorage.setItem(WL_META, JSON.stringify(meta));
  },

  touch(key) {
    if (!key) return;
    const meta = this.readMeta();
    if (!meta[key]) meta[key] = { addedAt: Date.now(), note: "" };
    else if (!meta[key].addedAt) meta[key].addedAt = Date.now();
    this.writeMeta(meta);
  },

  remove(key) {
    const meta = this.readMeta();
    delete meta[key];
    this.writeMeta(meta);
  },

  getNote(key) {
    return this.readMeta()[key]?.note || "";
  },

  setNote(key, note) {
    if (!key) return;
    const meta = this.readMeta();
    if (!meta[key]) meta[key] = { addedAt: Date.now(), note: "" };
    meta[key].note = String(note || "").slice(0, 500);
    this.writeMeta(meta);
  },

  getAddedAt(key) {
    const val = this.readMeta()[key]?.addedAt;
    return typeof val === "number" ? val : 0;
  },

  migrate(items) {
    const meta = this.readMeta();
    let changed = false;
    items.forEach((key) => {
      if (!meta[key]) {
        meta[key] = { addedAt: Date.now(), note: "" };
        changed = true;
      }
    });
    if (changed) this.writeMeta(meta);
  },
};

window.WishlistMeta = WishlistMeta;

const wishlistDiv = document.querySelector(".wishlist-page-main");

var WishlistPageShopify = (function () {
  let config = {};

  function readConfig() {
    const node = document.getElementById("wl-page-config");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function buildSearchQuery(items) {
    if (!Array.isArray(items) || items.length === 0) return "";
    return items
      .map((item) => {
        const value = String(item || "").trim();
        if (!value) return "";
        if (/^\d+$/.test(value)) return `id:${value}`;
        return `handle:${value}`;
      })
      .filter(Boolean)
      .join(" OR ");
  }

  function getCards() {
    return wishlistDiv
      ? Array.from(wishlistDiv.querySelectorAll("[data-wl-card]"))
      : [];
  }

  function getCardKey(card) {
    return card?.dataset?.productHandle || card?.dataset?.productId || "";
  }

  function readProductData(card) {
    const node = card?.querySelector(".wl-product-data");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function setPageState({ showPanel, showEmpty }) {
    const panel = wishlistDiv?.querySelector("[data-wl-results], .wishlist-results");
    const empty = wishlistDiv?.querySelector("[data-wl-empty], .wishlist-no-product-js");
    const toolbar = wishlistDiv?.querySelector("[data-wl-toolbar]");
    const sticky = document.querySelector("[data-wl-sticky]");
    if (panel) panel.classList.toggle("hidden", !showPanel);
    if (empty) empty.classList.toggle("hidden", !showEmpty);
    if (toolbar) toolbar.classList.toggle("hidden", !showPanel);
    if (sticky) {
      sticky.classList.toggle("hidden", !showPanel);
      sticky.setAttribute("aria-hidden", showPanel ? "false" : "true");
    }
  }

  function getMoneyFormat() {
    if (
      typeof themeGlobalVariables !== "undefined" &&
      themeGlobalVariables.settings &&
      themeGlobalVariables.settings.money_format
    ) {
      return themeGlobalVariables.settings.money_format;
    }
    if (typeof cartStrings !== "undefined" && cartStrings.money_format) {
      return cartStrings.money_format;
    }
    if (typeof Shopify !== "undefined" && Shopify.money_format) {
      return Shopify.money_format;
    }
    return "{{amount_with_comma_separator}} €";
  }

  function formatMoney(cents) {
    const amount = Number(cents) || 0;
    try {
      if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(amount, getMoneyFormat());
      }
    } catch (e) {
      console.warn("[wishlist] formatMoney fallback", e);
    }
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(amount / 100);
    } catch (e) {
      return (amount / 100).toFixed(2).replace(".", ",") + " €";
    }
  }

  function updateSummary() {
    const cards = getCards();
    const countEl = wishlistDiv?.querySelector("[data-wl-count]");
    const stickyCount = document.querySelector("[data-wl-sticky-count]");
    const stickyTotal = document.querySelector("[data-wl-sticky-total]");
    const n = cards.length;
    const strings = config.strings || {};

    if (countEl) {
      countEl.textContent =
        n === 1
          ? (strings.countOne || "1 Artikel").replace("{{ count }}", "1")
          : (strings.countOther || "{{ count }} Artikel").replace(
              "{{ count }}",
              String(n)
            );
    }

    let total = 0;
    cards.forEach((card) => {
      const data = readProductData(card);
      if (data?.price) total += Number(data.price);
    });

    const totalLabel = formatMoney(total);
    if (stickyCount) {
      stickyCount.textContent =
        n === 1
          ? strings.countOne || "1 Artikel"
          : (strings.countOther || "{{ count }} Artikel").replace(
              "{{ count }}",
              String(n)
            );
    }
    if (stickyTotal) {
      stickyTotal.textContent = total > 0 ? " · " + totalLabel : "";
    }
  }

  function applyNotes() {
    getCards().forEach((card) => {
      const key = getCardKey(card);
      const field = card.querySelector("[data-wl-note]");
      const addedAt = WishlistMeta.getAddedAt(key);
      if (field) field.value = WishlistMeta.getNote(key);
      if (addedAt) card.dataset.addedAt = String(addedAt);
    });
  }

  function syncCompareCheckboxes() {
    let compareItems = [];
    try {
      compareItems = JSON.parse(localStorage.getItem("mm__compare-items") || "[]");
    } catch (e) {
      compareItems = [];
    }
    if (!Array.isArray(compareItems)) compareItems = [];

    wishlistDiv?.querySelectorAll("[data-wl-compare]").forEach((input) => {
      const key = input.dataset.productHandle || input.dataset.productId;
      input.checked = compareItems.includes(key) || compareItems.includes(String(input.dataset.productId));
    });
  }

  function sortCards(mode) {
    const grid = wishlistDiv?.querySelector("[data-wl-grid]");
    if (!grid) return;

    const cards = getCards();
    const sorted = cards.slice().sort((a, b) => {
      const keyA = getCardKey(a);
      const keyB = getCardKey(b);
      const dataA = readProductData(a);
      const dataB = readProductData(b);

      switch (mode) {
        case "added_asc":
          return WishlistMeta.getAddedAt(keyA) - WishlistMeta.getAddedAt(keyB);
        case "title_asc":
          return (a.dataset.productTitle || "").localeCompare(
            b.dataset.productTitle || "",
            "de"
          );
        case "title_desc":
          return (b.dataset.productTitle || "").localeCompare(
            a.dataset.productTitle || "",
            "de"
          );
        case "price_asc":
          return Number(dataA?.price || 0) - Number(dataB?.price || 0);
        case "price_desc":
          return Number(dataB?.price || 0) - Number(dataA?.price || 0);
        case "available_first": {
          const avA = dataA?.available ? 0 : 1;
          const avB = dataB?.available ? 0 : 1;
          if (avA !== avB) return avA - avB;
          return WishlistMeta.getAddedAt(keyB) - WishlistMeta.getAddedAt(keyA);
        }
        case "added_desc":
        default:
          return WishlistMeta.getAddedAt(keyB) - WishlistMeta.getAddedAt(keyA);
      }
    });

    sorted.forEach((card) => {
      const wrap = card.closest(".wishlist-list");
      if (wrap) grid.appendChild(wrap);
    });

    mergeItemsFromDom();
  }

  function mergeItemsFromDom(allowEmptyWrite) {
    const items = [];
    const seen = new Set();
    getCards().forEach((card) => {
      const key = getCardKey(card);
      if (!key || seen.has(key)) return;
      seen.add(key);
      items.push(key);
    });
    if (items.length === 0 && !allowEmptyWrite) {
      return WishlistMeta.readItems();
    }
    WishlistMeta.writeItems(items);
    WishlistMeta.migrate(items);
    return items;
  }

  function countRenderedCards(root) {
    if (!root) return 0;
    return root.querySelectorAll("[data-wl-card]").length;
  }

  function importShareParam() {
    try {
      const params = new URLSearchParams(window.location.search);
      const wl = params.get("wl");
      if (!wl) return false;
      const incoming = wl
        .split(",")
        .map((s) => decodeURIComponent(s.trim()))
        .filter(Boolean);
      if (!incoming.length) return false;
      const current = WishlistMeta.readItems();
      const merged = [...current];
      incoming.forEach((key) => {
        if (!merged.includes(key)) {
          merged.push(key);
          WishlistMeta.touch(key);
        }
      });
      WishlistMeta.writeItems(merged);
      params.delete("wl");
      const qs = params.toString();
      const next = window.location.pathname + (qs ? "?" + qs : "");
      window.history.replaceState({}, "", next);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getShareUrl() {
    const items = WishlistMeta.readItems();
    if (!items.length) return window.location.href.split("?")[0];
    const base = window.location.href.split("?")[0];
    return base + "?wl=" + encodeURIComponent(items.join(","));
  }

  function toggleCompare(input) {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem("mm__compare-items") || "[]");
    } catch (e) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    const key = input.dataset.productHandle || input.dataset.productId;
    if (input.checked) {
      if (!list.includes(key)) list.push(key);
      if (input.dataset.productId && !list.includes(input.dataset.productId)) {
        list.push(input.dataset.productId);
      }
    } else {
      list = list.filter((item) => item !== key && item !== input.dataset.productId);
    }
    localStorage.setItem("mm__compare-items", JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent("theme:compare-updated", { detail: { count: list.length } })
    );
    window.themeHeaderCounters?.refreshCompare?.();
  }

  let shareFeedbackTimer = null;

  function showShareFeedback(shareBtn) {
    const wrap = shareBtn?.closest("[data-wl-share-wrap]");
    const feedback = wrap?.querySelector("[data-wl-share-feedback]");
    if (!feedback) return;
    feedback.textContent = config.strings?.shareCopied || "";
    feedback.hidden = false;
    feedback.classList.add("wl-share-feedback--visible");
    if (shareFeedbackTimer) clearTimeout(shareFeedbackTimer);
    shareFeedbackTimer = setTimeout(() => {
      feedback.hidden = true;
      feedback.classList.remove("wl-share-feedback--visible");
    }, 3500);
  }

  function bindPageEvents() {
    if (!wishlistDiv || wishlistDiv.dataset.wlBound === "true") return;
    wishlistDiv.dataset.wlBound = "true";

    wishlistDiv.addEventListener("change", (e) => {
      const compare = e.target.closest("[data-wl-compare]");
      if (compare) {
        toggleCompare(compare);
        return;
      }
      const sort = e.target.closest("[data-wl-sort]");
      if (sort) {
        localStorage.setItem(WL_SORT, sort.value);
        sortCards(sort.value);
        updateSummary();
      }
    });

    wishlistDiv.addEventListener("input", (e) => {
      const note = e.target.closest("[data-wl-note]");
      if (note) WishlistMeta.setNote(note.dataset.productHandle, note.value);
    });

    wishlistDiv.addEventListener("click", (e) => {
      const shareBtn = e.target.closest("[data-wl-share]");
      if (shareBtn) {
        const url = getShareUrl();
        if (navigator.clipboard?.writeText) {
          navigator.clipboard
            .writeText(url)
            .then(() => showShareFeedback(shareBtn))
            .catch(() => {
              window.prompt(config.strings?.shareCopied, url);
            });
        } else {
          window.prompt(config.strings?.shareCopied, url);
        }
        return;
      }

      const clearBtn = e.target.closest("[data-wl-clear]");
      if (clearBtn) {
        if (!window.confirm(config.strings?.clearConfirm)) return;
        WishlistMeta.writeItems([]);
        WishlistMeta.writeMeta({});
        setPageState({ showPanel: false, showEmpty: true });
        return;
      }

    });

    const sticky = document.querySelector("[data-wl-sticky]");
    if (sticky && !sticky.dataset.wlScrollBound) {
      sticky.dataset.wlScrollBound = "true";
      const onScroll = () => {
        const show = window.scrollY > 320 && getCards().length > 0;
        sticky.classList.toggle("wl-sticky--visible", show);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
  }

  function enhancePage() {
    applyNotes();
    syncCompareCheckboxes();
    const sortMode = localStorage.getItem(WL_SORT) || "added_desc";
    const sortSelect = wishlistDiv?.querySelector("[data-wl-sort]");
    if (sortSelect) sortSelect.value = sortMode;
    sortCards(sortMode);
    bindPageEvents();
    setPageState({ showPanel: true, showEmpty: false });
    try {
      updateSummary();
    } catch (e) {
      console.warn("[wishlist] updateSummary failed", e);
    }
  }

  function injectWishlistProducts(result, targetRow) {
    if (!targetRow) return false;

    const doc = result.html;

    if (doc) {
      const preloads = doc.querySelectorAll("[data-wl-preload]");
      if (preloads.length > 0) {
        targetRow.innerHTML = "";
        preloads.forEach((preload) => {
          const sourceCol = preload.querySelector(".wishlist-list");
          if (sourceCol) targetRow.appendChild(sourceCol.cloneNode(true));
        });
        if (countRenderedCards(targetRow) > 0) return true;
      }
    }

    if (result.sourceList && countRenderedCards(result.sourceList) > 0) {
      targetRow.innerHTML = result.sourceList.innerHTML;
      return countRenderedCards(targetRow) > 0;
    }

    if (result.sourceContainer) {
      const fallback = result.sourceContainer.querySelector(".wishlist-list-items");
      if (fallback && countRenderedCards(fallback) > 0) {
        targetRow.innerHTML = fallback.innerHTML;
        return countRenderedCards(targetRow) > 0;
      }
    }

    if (result.searchResults) {
      targetRow.innerHTML = "";
      result.searchResults.querySelectorAll(".grid__item").forEach((item) => {
        item.className =
          "col-6 col-md-4 col-lg-3 product-load wl-product-js wishlist-list";
        targetRow.appendChild(item);
      });
      return countRenderedCards(targetRow) > 0;
    }

    return false;
  }

  function scanDynamicModules(container) {
    if (!container) return;
    if (window.theme?.scanModules) {
      window.theme.scanModules(container);
      return;
    }
    document.dispatchEvent(
      new CustomEvent("theme:dom-updated", { detail: { container } })
    );
  }

  return {
    initWishlistItems() {
      if (window.location.search.indexOf("page=") !== -1) return;
      this.init();
    },

    init() {
      config = readConfig();
      if (!wishlistDiv) return;

      importShareParam();

      let items = WishlistMeta.readItems();
      WishlistMeta.migrate(items);

      const emptyEl = wishlistDiv.querySelector("[data-wl-empty], .wishlist-no-product-js");
      const listRow = wishlistDiv.querySelector("[data-wl-grid], .wishlist-list-items");

      if (!items.length) {
        setPageState({ showPanel: false, showEmpty: true });
        bindPageEvents();
        return;
      }

      const query = buildSearchQuery(items);
      if (!query) {
        setPageState({ showPanel: false, showEmpty: true });
        return;
      }

      const wishlistSection = document.querySelector(".wishlist-page-section");
      const dynamicSectionId = wishlistSection?.dataset?.sectionId || "";
      const sectionIds = ["page-wishlist", dynamicSectionId, "main"].filter(
        (v, i, a) => Boolean(v) && a.indexOf(v) === i
      );

      const fetchSection = (index) => {
        const sectionId = sectionIds[index];
        const url =
          "?section_id=" +
          sectionId +
          "&type=product&options[unavailable_products]=last&q=" +
          encodeURIComponent(query);
        return fetch(`${window.routes.search_url}${url}`)
          .then((r) => r.text())
          .then((htmlText) => {
            const html = new DOMParser().parseFromString(htmlText, "text/html");
            const sourceContainer = html.querySelector(".wishlist-page-main");
            const sourceList = sourceContainer?.querySelector(".wishlist-list-items");
            const cardCount = countRenderedCards(html);
            const searchResults = html.querySelector("#product-grid");
            const searchCount = searchResults
              ? searchResults.querySelectorAll(".grid__item").length
              : 0;
            const hasProducts = cardCount > 0 || searchCount > 0;
            if (!hasProducts && index + 1 < sectionIds.length) {
              return fetchSection(index + 1);
            }
            return { hasProducts, sourceContainer, sourceList, searchResults, html };
          });
      };

      fetchSection(0)
        .then((result) => {
          if (items.length && result?.hasProducts) {
            const row = listRow || wishlistDiv.querySelector(".wishlist-list-items");
            if (injectWishlistProducts(result, row)) {
              enhancePage();
              scanDynamicModules(wishlistDiv);
            } else {
              setPageState({ showPanel: false, showEmpty: true });
            }
          } else {
            setPageState({ showPanel: false, showEmpty: true });
          }
          if (wishlistDiv.querySelectorAll("[data-wl-card]").length > 0) {
            mergeItemsFromDom();
          }
        })
        .catch((e) => {
          console.error(e);
          const hasCards =
            wishlistDiv.querySelectorAll("[data-wl-card]").length > 0;
          if (hasCards) {
            setPageState({ showPanel: true, showEmpty: false });
            try {
              bindPageEvents();
              updateSummary();
            } catch (err) {
              console.warn("[wishlist] recovery after error", err);
            }
          } else {
            setPageState({ showPanel: false, showEmpty: true });
          }
        })
        .finally(() => {
          if (typeof initLazyloadItem === "function") initLazyloadItem();
        });

      bindPageEvents();
    },
  };
})();

WishlistPageShopify.initWishlistItems();

document.addEventListener("theme:wishlist-updated", () => {
  if (!wishlistDiv) return;
  const count = WishlistMeta.readItems().length;
  if (count === 0) {
    WishlistPageShopify.init();
  }
});

document.addEventListener("wl:page-changed", () => {
  if (!wishlistDiv) return;
  const cards = wishlistDiv.querySelectorAll("[data-wl-card]");
  if (cards.length === 0) {
    const panel = wishlistDiv.querySelector("[data-wl-results], .wishlist-results");
    const empty = wishlistDiv.querySelector("[data-wl-empty], .wishlist-no-product-js");
    const toolbar = wishlistDiv.querySelector("[data-wl-toolbar]");
    const sticky = document.querySelector("[data-wl-sticky]");
    panel?.classList.add("hidden");
    empty?.classList.remove("hidden");
    toolbar?.classList.add("hidden");
    sticky?.classList.add("hidden");
    return;
  }
  const sortMode = localStorage.getItem(WL_SORT) || "added_desc";
  const grid = wishlistDiv.querySelector("[data-wl-grid]");
  if (grid) {
    const sorted = Array.from(cards).sort((a, b) => {
      const keyA = a.dataset.productHandle || "";
      const keyB = b.dataset.productHandle || "";
      return WishlistMeta.getAddedAt(keyB) - WishlistMeta.getAddedAt(keyA);
    });
    sorted.forEach((card) => {
      const wrap = card.closest(".wishlist-list");
      if (wrap && grid) grid.appendChild(wrap);
    });
  }
  const countEl = wishlistDiv.querySelector("[data-wl-count]");
  let strings = {};
  try {
    strings = JSON.parse(document.getElementById("wl-page-config")?.textContent || "{}").strings || {};
  } catch (e) {
    strings = {};
  }
  const n = cards.length;
  if (countEl) {
    countEl.textContent =
      n === 1
        ? strings.countOne || "1 Artikel"
        : (strings.countOther || "{{ count }} Artikel").replace("{{ count }}", String(n));
  }
});
